module.exports = __webpack_public_path__ + "img/my_active_icon@2x.b8f6cfd5.png";